"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentController = void 0;
const ParentController_1 = __importDefault(require("../ParentController"));
class CommentController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            edit: 'v1/comment/:objectId',
            delete: 'v1/comment/:objectId',
            createOnParent: '/v1/:parent/:objectId/comment',
        };
    }
    create({}) {
        throw new Error('Impossible to create a comment outside a scope!');
    }
    createOnParent(procedure, parent, objectId) {
        return this.manager.post({
            url: this.endpoints.createOnParent,
            params: { objectId, parent },
        }, procedure);
    }
}
exports.CommentController = CommentController;
